import { isPresent } from './utilities'
import moment from 'moment';
import V from 'validator'
import { get } from 'lodash'
import store from './store'

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

export const validator = async (value, key, fields = null) => {
  if (typeof key == 'boolean' && key == true) {
    return { valid: !!value, failedValidation: null }
  }
  if (typeof value == 'boolean') {
    return { valid: true, failedValidation: null }
  }
  const requiredFields = store.getState().requiredFields
  let valueValid = value != '' && value != undefined && value != null
  let keyValid = key && requiredFields[key]
  if (!valueValid || !keyValid) { return null }

  let valid = false;
  let failedValidation = null;
  let linkedFields = fields
  const requiredValidations = requiredFields[key].validations
  const validationKeys = requiredValidations ? Object.keys(requiredValidations) : []

  const validateString = () => {
    let regexp = new RegExp(/^[\w\s\-\\,\/'àâçéèêëîïôûùüÿñæœ]{2,}$/);
    return regexp.test(value);
  }

  const validateBoolean = () => {
    let validBoolean = (
      typeof value === 'boolean' ||
      (
        typeof value === 'string' &&
        ['true', 'false'].includes(value)
      )
    )
    return validBoolean || null
  }

  const validatePassword = () => {
    let regexp = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/);
    failedValidation = 'password'
    return regexp.test(value);
  }

  const validatePlace = () => {
    failedValidation = 'place'
    return isPresent(value) && String(value) !== '-1'
  }

  const validateName = () => {
    let regexp = new RegExp(/^[a-zA-Z \-\']{2,40}$/); //Letters only, no special characters, spaces permitted, 2-40 character length
    return regexp.test(value);
  }

  const validatePhone = () => {
    return V.isMobilePhone(value)
  }

  const validatePresence = () => {
    if (!value) { return false }
    let present;
    switch (typeof value) {
      case 'string':
        present = isPresent(value)
        break
      case 'boolean':
        present = true
        break
      default:
        present = value && value.length > 0
        break
    }
    return present
  }

  const validateTime = () => {
    if (!value) return false

    if (!linkedFields) return true

    const isArrival = key == 'arrival_time'
    const sameDate = linkedFields.arrivalDate.val == linkedFields.pickupDate.val
    const linkedTime = isArrival ? linkedFields.pickupTime.val : linkedFields.arrivalTime.val

    if (sameDate) {
      if (isArrival) {
        linkedFields.pickupTime.valid = linkedTime > value
        return linkedTime > value
      } else {
        linkedFields.arrivalTime.valid = value > linkedTime
        return value > linkedTime
      }
    }

    return true
  }

  const updateTimeValidation = () => {
    const arrivalTime = linkedFields.arrivalTime.val
    const pickupTime = linkedFields.pickupTime.val

    if (arrivalTime && pickupTime) {
      linkedFields.pickupTime.valid = pickupTime > arrivalTime
      linkedFields.arrivalTime.valid = pickupTime > arrivalTime
    }
  }

  const validateDate = () => {
    if (typeof value != 'string') { return null }
    if (value == null || value == '') { return false }
    // Check if date is iso8601 format
    const iso8601Date = new RegExp(/^(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/)
    if (!iso8601Date.test(value)) { return false }
    const momentDate = moment(value)
    const maxDate = moment().add(3, 'years')
    let conditions = requiredValidations['date']
    let date = new Date(value)
    let latestDate = new Date(conditions.latest_date)
    let earliestDate = new Date(conditions.earliest_date)

    if (momentDate.isAfter(maxDate)) {
      failedValidation = 'afterMaxDate'
      return false
    } else if (earliestDate && date < earliestDate) {
      failedValidation = 'lessThanMimimum'
      return false
    } else if (latestDate && date > latestDate) {
      failedValidation = 'greaterThanMaximum'
      return false
    } else if (key == 'pickup_date' && linkedFields && linkedFields.arrivalDate.val) {
      let linkedDate = new Date(linkedFields.arrivalDate.val)

      if (linkedDate > date) return false

      if (linkedFields.arrivalDate.val == value) {
        linkedFields.arrivalDate.valid = true
        updateTimeValidation()
      }

      return true
    } else if (key == 'arrival_date' && linkedFields && linkedFields.pickupDate.val) {
      let linkedDate = new Date(linkedFields.pickupDate.val)

      if (date > linkedDate) return false

      if (value == linkedFields.pickupDate.val) {
        linkedFields.pickupDate.valid = true
        updateTimeValidation()
      }

      return true
    } else if (key == 'profile_elements_placement_intended_start' && linkedFields && linkedFields.val) {
      let intendedVacate = new Date(linkedFields.val)

      if (date > intendedVacate) return false

      linkedFields.valid = true

      return true
    } else if (key == 'profile_elements_placement_intended_vacate' && linkedFields && linkedFields.val) {
      let intendedStart = new Date(linkedFields.val)

      if (intendedStart > date) return false

      linkedFields.valid = true

      return true
    } else {
      return true
    }
  }

  const validateEmailFormat = () => {
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    failedValidation = 'emailFormat'
    return regexp.test(value);
  }

  const validateFile = () => (
    value instanceof File
  )

  const validateArray = () => {
    let conditions = requiredValidations['array']
    return value.length >= conditions.minimum_size
  }

  const validateEmailUnique = () => {
    failedValidation = 'emailUnique'
    return new Promise(async (resolve) => {
      let formUrl = `/validate_email.json?email=${value}`;
      await fetch(formUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(response => response.json())
        .then(data => {
          resolve(data.valid)
        })
    })
  }

  const validate = async () => {
    return await new Promise(async (resolve) => {
      if (validationKeys.length > 0) {
        for (let key of validationKeys) {
          switch (key) {
            case 'email_format':
              valid = await validateEmailFormat()
              break;
            case 'email_unique':
              valid = await validateEmailUnique()
              break;
            case 'name':
              valid = await validateName()
              break;
            case 'phone':
              valid = await validatePhone()
              break;
            case 'date':
              valid = await validateDate()
              break;
            case 'time':
              valid = await validateTime()
              break;
            case 'string':
              valid = await validateString()
              break;
            case 'boolean':
              valid = await validateBoolean()
              break;
            case 'password':
              valid = await validatePassword()
              break;
            case 'file':
              valid = await validateFile()
              break;
            case 'place':
              valid = await validatePlace()
              break;
            case 'array':
              valid = await validateArray()
              break;
            default:
              valid = false
              break;
          }
          if (!valid) { break; }
        }
      } else {
        valid = await validatePresence()
      }
      resolve(valid)
    })
  }

  return validate().then(valid => ({
    valid: valid,
    failedValidation: failedValidation,
    linkedFields: linkedFields
  }))
}

export const fieldsToValidate = (state) => {
  const requiredFields = store.getState().requiredFields
  const activeProfileElements = get(store.getState(), 'user.guest.type.guest_profile_elements', [])
  return (
    typeof state == 'object'
      ? Object.keys(state).filter((key) => {
        let field = state[key]
        if (!field || typeof field != 'object') { return false }
        let profileElement = field.profileElement
        let validationKey = field.validationKey
        let validationKeyExists = (typeof validationKey === 'boolean' && validationKey == true) || (validationKey && typeof requiredFields[validationKey] == 'object')
        let fieldActive = (typeof profileElement === 'boolean' && profileElement == true) || (profileElement && activeProfileElements.includes(profileElement))
        let dependencyMet = typeof field.dependencyMet != 'function' || field.dependencyMet(state[field.dependentObj])
        return validationKeyExists && fieldActive && dependencyMet
      })
      : []
  )
}

export const pageValid = (state) => (
  fieldsToValidate(state).every((field) => {
    let isValid;
    if (field == 'intendedVacate') {
      isValid = state[field].valid == true || (!state[field].valid && !state[field].val)
    } else {
      isValid = state[field].valid == true
    }

    if (!isValid && window.location.search.includes('debug=true')) {
      console.log('Field failed validation:', field, state[field]);
    }

    return isValid;
  })
)

export const executeValidations = (component) => {
  fieldsToValidate(component.state).forEach(async (field) => {
    let result = await validator(
      component.state[field].val,
      component.state[field].validationKey
    )
    let obj = component.state[field]
    obj.valid = get(result, 'valid')
    obj.failedValidation = get(result, 'failedValidation')
    component.setState({ [field]: obj });
  })
}
